/**
 * ProjectMessageService
 * Service for ProjectMessage entity operations
 * Route: api/project-messages
 * Controller: ProjectMessageController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectMessageService
 * Handles project message CRUD operations
 * Maps to /api/project-messages endpoint
 */
export class ProjectMessageService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectMessageService.DEFAULT_SERVICE_PATH,
            basePath: ProjectMessageService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectMessageService.DEFAULT_SERVICE_PATH = 'projects';
ProjectMessageService.BASE_PATH = 'api/project-messages';
//# sourceMappingURL=ProjectMessageService.js.map